import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { LoadingPage } from '../pages/LoadingPage';

export const OAuthRedirect = () => {
  const auth = useAuth();
  const [retrySignIn, setRetrySignIn] = useState(false);

  useEffect(() => {
    //On invalid/stale state for oauth redirect make a new sign in request to cleanup old request state
    if (!auth.isLoading && !retrySignIn && auth.error) {
      setRetrySignIn(true);
      auth.signinRedirect();
    }
  }, [auth, auth.error, retrySignIn]);
  return <LoadingPage />;
};
